import axios from 'axios';
import { scopes } from 'config/authConfig';
import jwtDecode from 'jwt-decode';
import { msalInstance } from './index';

export default class TokenCredential {
  // TODO: implement GetTokenOptions
  /* eslint-disable class-methods-use-this */
  async getToken(): Promise<{
    token: string;
    expiresOnTimestamp: number;
  } | null> {
    const accounts = msalInstance.getAllAccounts();
    const account = accounts[0] || null;
    try {
      if (account) {
        const tokenResponse = await msalInstance.acquireTokenSilent({ scopes, account });
        const decoded = jwtDecode<{ exp: string }>(tokenResponse.accessToken);
        return {
          token: tokenResponse.accessToken,
          expiresOnTimestamp: Number(decoded.exp),
        };
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    return { token: '', expiresOnTimestamp: 0 };
  }
}

// acquire token method
export const getToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  const account = accounts[0] || null;
  try {
    if (account) {
      const tokenResponse = await msalInstance.acquireTokenSilent({ scopes, account });
      const token = tokenResponse.accessToken.toString();
      return token;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
  return '';
};

export const setGlobalHeaders = async () => {
  // sets global headers
  const accessToken = await getToken();
  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  axios.defaults.headers.common['Content-Type'] = `application/json`;
};
